import { Component, Input, OnInit } from '@angular/core';
import { LabeledInputComponent } from "../../../../../shared/components/labeled-input/labeled-input.component";
import { CustomDropdownComponent } from "../../../../../shared/components/custom-dropdown/custom-dropdown.component";
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { combineLatest, firstValueFrom } from 'rxjs';
import { AuthValidatorService } from '../../../../../core/services/validators/auth-validator.service';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../../../core/api/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../../core/api/api-error.service';
import { ToastComponent } from '../../../../../shared/components/toast/toast.component';

@Component({
  selector: 'app-invite-new-member-dialog',
  standalone: true,
  imports: [LabeledInputComponent, CustomDropdownComponent, CustomButtonComponent, TranslocoPipe, CommonModule],
  templateUrl: './invite-new-member-dialog.component.html',
  styleUrl: './invite-new-member-dialog.component.css'
})
export class InviteNewMemberDialogComponent implements OnInit {
  modalDialogId: string = 'settings_modal_invite_member'

  // Text Inputs
  inviteEmailInput: string = '';
  inviteEmailInputError: string | null = null;

  inviteLinkInput: string = '';
  inviteLinkInputError: string | null = null;

  // Dropdown Menu
  rolesOptions: string[] = [];
  selectedRole: number | undefined;
  serverRoleOptions: string[] = [];
  selectRoleShowError: boolean = false;

  showErrorMessage: string | null = null;

  // Invited state
  userInvited: boolean = false;

  openModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();

      this.inviteEmailInput = '';
      this.inviteLinkInput = '';
      this.selectedRole = undefined;
      this.userInvited = false;
      this.selectRoleShowError = false;
      this.showErrorMessage = null;

      this.serverRoleOptions = ["ADMIN", "MANAGER", "SR_MANAGER", "DIRECTOR"];
    }
  }

  closeModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
    }
  }

  constructor(private translocoService: TranslocoService, private authValidator: AuthValidatorService, private userService: UserService, private apiError: ApiErrorService) { }

  ngOnInit(): void {
    const roleKeys = [
      'shared.roles.admin',
      'shared.roles.manager',
      'shared.roles.sr_manager',
      'shared.roles.director'
    ];

    combineLatest(roleKeys.map((key) => this.translocoService.selectTranslate(key))).subscribe((translations) => {
      this.rolesOptions = translations;
    });
  }

  copyInviteLink() {
    navigator.clipboard.writeText(this.inviteLinkInput)
      .catch(err => {
        throw new Error(`Failed to copy invite link: ${err.message}`);
      });
  }

  async inviteUserButtonClick() {
    this.showErrorMessage = null;
    const emailInputValue = this.inviteEmailInput.trim();

    const emailError = this.authValidator.validateEmail(emailInputValue);
    if (emailError) {
      this.inviteEmailInputError = emailError;
      return;
    }

    const finalRole = this.selectedRole === undefined ? 'UNDEFINED' : this.serverRoleOptions.at(this.selectedRole!);
    if (finalRole === 'UNDEFINED') {
      this.selectRoleShowError = true;
      return;
    }
    this.inviteEmailInputError = null;
    this.selectRoleShowError = false;

    let response = undefined;
    try {
      response = await firstValueFrom(this.userService.createInviteLink(emailInputValue, finalRole!));

      this.inviteLinkInput = response.invite_url;
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        if (error.error.code == 'SVC-4070') {
          this.showErrorMessage = this.translocoService.translate('settings.email_used');
          return;
        }
      }

      this.showErrorMessage = await this.apiError.getErrorMessage(crid);
      return;
    }
    this.userInvited = true;
  }
}
